import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DOMPurify from "dompurify";
import Header from "./Header";
import { Pagination } from "react-bootstrap";
import {
  FaPen,
  FaEye,
  FaUser,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaUtensils,
  FaStore,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import {
  Calendar,
  Search,
  UserPlus,
  Filter,
  Download,
  MessageSquare,
  Underline,
  LucideWebhook,
} from "lucide-react";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import { Modal, Button } from "react-bootstrap";
import { GuestManagementPageText } from "./../CommonJquery/WebsiteText";
import {
  server_post_data,
  get_lead,
  update_lead,
  contact_save,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  computeTodayDate,
  handleEmailChange,
  computeplussevendays,
  formatDateStringdot,
  handleSuccess,
  combiled_form_data,
  check_vaild_save,
} from "../CommonJquery/CommonJquery";
import "./Css/WebsiteMngmt.css";

// ---- Security helpers -------------------------------------------------
// Strip all HTML/script tags from free-text input. Defense-in-depth only —
// the backend must independently sanitize + validate on save.
const sanitizeText = (val) =>
  DOMPurify.sanitize((val ?? "").toString(), {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  }).trim();

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[0-9+\-\s()]{7,15}$/;
const ALLOWED_STATUS = ["0", "1", "2", "3", "4", "5", "10"];
// -------------------------------------------------------------------------

function LeadManagement() {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState("");
  const [filterOption, setFilterOption] = useState("all");
  const [expandedRows, setExpandedRows] = useState([]);
  const [assignToValue, setAssignToValue] = useState("");

  const convertToDate = (dateString) => {
    if (!dateString) return new Date();
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  const [isFormValid, setIsFormValid] = useState(true);

  const handleSaveChanges_add = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    if (vaild_data) {
      // Extra client-side checks that trio_mandatory alone doesn't cover
      const rawEmail = document.getElementById("email_address")?.value || "";
      const rawPhone = document.getElementById("phone_number")?.value || "";

      if (rawEmail && !EMAIL_REGEX.test(rawEmail.trim())) {
        handleError("Please enter a valid email address");
        return;
      }
      if (rawPhone && !PHONE_REGEX.test(rawPhone.trim())) {
        handleError("Please enter a valid phone number");
        return;
      }
      if (!ALLOWED_STATUS.includes(dropdownoptions)) {
        handleError("Invalid status selected");
        return;
      }

      setIsFormValid(true);
      let fd_from = combiled_form_data(form_data, null);

      // Sanitize every free-text field before it leaves the browser
      const textFields = [
        "full_name",
        "email_address",
        "phone_number",
        "city",
        "restaurant_name",
        "restaurant_type",
        "no_outlets",
        "message",
      ];
      textFields.forEach((key) => {
        if (fd_from.has(key)) {
          fd_from.set(key, sanitizeText(fd_from.get(key)));
        }
      });
      fd_from.set("status", dropdownoptions);

      setshowLoaderAdmin(true);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            closeEditModal();
            master_data_get(
              formatDateForAPI(startDate),
              formatDateForAPI(endDate),
              flagData,
              "0",
            );
            handleSuccess(Response.data.message);
          }
          setshowLoaderAdmin(false);
        })
        .catch((error) => {
          handleError("network");
          setshowLoaderAdmin(false);
        });
    }
  };

  const handleInputChange = (key, value) => {
    const updatedData = { ...SelectedData, [key]: value };
    setSelectedData(updatedData);
  };

  const [startDate, setStartDate] = useState(
    convertToDate(computeplussevendays()),
  );
  const [endDate, setEndDate] = useState(convertToDate(computeTodayDate()));
  const [SelectedData, setSelectedData] = useState([]);
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [flagData, setflagData] = useState("1");
  const [selectedOption, setSelectedOption] = useState("All");
  const [searchText, setSearchText] = useState("");
  const [selectedValue, setSelectedValue] = useState("Name");
  const [dropdownoptions, setdropdownoption] = useState("1");
  const [rejectresion, setrejectresion] = useState("");
  const [clickedButton1, setClickedButton1] = useState(null);

  const handleSelect = (event) => {
    setSelectedValue(event.target.value);
  };

  const formatDateForAPI = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const openShowModal = () => {
    setdropdownoption("1");
    setrejectresion("");
    setShowAddModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setShowAddModal(false);
    setShowAssignModal(false);
  };

  const closeDetailtModal = () => {
    setShowDetailModal(false);
  };

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get(
      formatDateForAPI(startDate),
      formatDateForAPI(endDate),
      flag,
      call_id,
    );
  }, []);

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    master_data_get(formatDate(startDate), formatDate(endDate), flag, call_id);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    fd.append("search_option", sanitizeText(selectedValue));
    fd.append("search_data", sanitizeText(searchText));
    await server_post_data(get_lead, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          seteditStaffData(Response.data.message.data_customerInformation);
          setfilteredData(Response.data.message.data_customerInformation);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const master_data_action_update = async () => {
    if (!ALLOWED_STATUS.includes(dropdownoptions)) {
      handleError("Invalid status selected");
      return;
    }
    if (dropdownoptions === "10" && !rejectresion.trim()) {
      handleError("Please enter a rejection reason");
      return;
    }

    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", clickedButton1);
    fd.append("status", dropdownoptions);
    fd.append("reject", sanitizeText(rejectresion));
    await server_post_data(update_lead, fd)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          closeModal1();
          master_data_get(
            formatDateForAPI(startDate),
            formatDateForAPI(endDate),
            flagData,
            "0",
          );
          setrejectresion("");
          handleSuccess("Lead updated successfully");
        }
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);

    const filteredDatashow = editStaffData.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredData(filteredDatashow);
  };

  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);

  const closeModal = () => setShowModal(false);
  const closeModal1 = () => setShowModal1(false);

  const openModal1 = (id, status) => {
    setClickedButton1(id);
    setdropdownoption(status.toString());
    setShowModal1(true);
  };

  const openDetailModal = (data) => {
    setSelectedRestaurant(data);
    setShowDetailModal(true);
  };

  const openAssignModal = (data) => {
    setSelectedRestaurant(data);
    setAssignToValue(data.assign_to || "");
    setShowAssignModal(true);
  };

  // Toggle row expansion
  const toggleRowExpansion = (id) => {
    if (expandedRows.includes(id)) {
      setExpandedRows(expandedRows.filter((rowId) => rowId !== id));
    } else {
      setExpandedRows([...expandedRows, id]);
    }
  };

  // Get status badge
  const getStatusBadge = (status) => {
    const statusMap = {
      0: { text: "Pending", color: "#ffc107", bgColor: "#fff3cd" },
      1: { text: "In Progress", color: "#17a2b8", bgColor: "#d1ecf1" },
      2: { text: "Completed", color: "#28a745", bgColor: "#d4edda" },
      3: { text: "Warm", color: "#fd7e14", bgColor: "#ffe5d0" },
      4: { text: "Cold", color: "#6c757d", bgColor: "#e2e3e5" },
      5: { text: "Hot", color: "#dc3545", bgColor: "#f8d7da" },
      10: { text: "Rejected", color: "#dc3545", bgColor: "#f8d7da" },
    };

    const badge = statusMap[status] || {
      text: "Unknown",
      color: "#6c757d",
      bgColor: "#e2e3e5",
    };

    return (
      <span
        style={{
          padding: "5px 12px",
          borderRadius: "20px",
          fontSize: "12px",
          fontWeight: "600",
          color: badge.color,
          backgroundColor: badge.bgColor,
          border: `1px solid ${badge.color}`,
        }}
      >
        {badge.text}
      </span>
    );
  };

  // Filter data by status
  const filterByStatus = (status) => {
    setFilterOption(status);
    if (status === "all") {
      setfilteredData(editStaffData);
    } else {
      const filtered = editStaffData.filter(
        (item) => item.active_status === parseInt(status),
      );
      setfilteredData(filtered);
    }
  };

  // Export to CSV
  const exportToCSV = () => {
    const headers = [
      "ID",
      "Entry Date",
      "Full Name",
      "Email",
      "Phone",
      "City",
      "Restaurant Name",
      "Restaurant Type",
      "No. of Outlets",
      "Message",
      "Status",
      "Remark",
      "Assigned To",
    ];

    const csvData = filteredData.map((item) => [
      item.primary_id,
      item.entry_date,
      item.full_name,
      item.email_address,
      item.phone_number,
      item.city,
      item.restaurant_name,
      item.restaurant_type,
      item.no_outlets,
      item.message,
      getStatusBadge(item.active_status).props.children,
      item.remark || "",
      item.assign_to || "",
    ]);

    // Escape embedded quotes and neutralize formula-injection characters
    // (=, +, -, @) that spreadsheet apps (Excel/Sheets) auto-execute.
    const csvSafeCell = (cell) => {
      let str = cell === null || cell === undefined ? "" : String(cell);
      if (/^[=+\-@]/.test(str)) {
        str = `'${str}`;
      }
      return str.replace(/"/g, '""');
    };

    const csv = [
      headers.join(","),
      ...csvData.map((row) =>
        row.map((cell) => `"${csvSafeCell(cell)}"`).join(","),
      ),
    ].join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `leads_${formatDate(new Date())}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  // Pagination
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Stats calculation
  const stats = {
    total: editStaffData.length,
    pending: editStaffData.filter((item) => item.active_status === 0).length,
    inProgress: editStaffData.filter((item) => item.active_status === 1).length,
    completed: editStaffData.filter((item) => item.active_status === 2).length,
    hot: editStaffData.filter((item) => item.active_status === 5).length,
    warm: editStaffData.filter((item) => item.active_status === 3).length,
    cold: editStaffData.filter((item) => item.active_status === 4).length,
    rejected: editStaffData.filter((item) => item.active_status === 10).length,
  };

  return (
    <>
      <div className="dashboard">
        {showLoaderAdmin && <Loader />}
        <div className="dashboard_container">
          <div className="page_content">
            <div className="page_content_container">
              <Header />
              <div className="pageCntn_head">
                <div className="pageNameDiv">
                  <p>Lead Management</p>
                  <img src={GreyArrow} alt="Arrow" />
                </div>
              </div>

              {/* Stats Cards */}
              <div
                className="stats-container"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
                  gap: "15px",
                  marginBottom: "20px",
                }}
              >
                <div
                  className="stat-card"
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    padding: "20px",
                    borderRadius: "10px",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => filterByStatus("all")}
                >
                  <div style={{ fontSize: "14px", opacity: 0.9 }}>
                    Total Leads
                  </div>
                  <div style={{ fontSize: "32px", fontWeight: "bold" }}>
                    {stats.total}
                  </div>
                </div>

                <div
                  className="stat-card"
                  style={{
                    background:
                      "linear-gradient(135deg, #ffc107 0%, #ff9800 100%)",
                    padding: "20px",
                    borderRadius: "10px",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => filterByStatus("0")}
                >
                  <div style={{ fontSize: "14px", opacity: 0.9 }}>Pending</div>
                  <div style={{ fontSize: "32px", fontWeight: "bold" }}>
                    {stats.pending}
                  </div>
                </div>

                <div
                  className="stat-card"
                  style={{
                    background:
                      "linear-gradient(135deg, #17a2b8 0%, #138496 100%)",
                    padding: "20px",
                    borderRadius: "10px",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => filterByStatus("1")}
                >
                  <div style={{ fontSize: "14px", opacity: 0.9 }}>
                    In Progress
                  </div>
                  <div style={{ fontSize: "32px", fontWeight: "bold" }}>
                    {stats.inProgress}
                  </div>
                </div>

                <div
                  className="stat-card"
                  style={{
                    background:
                      "linear-gradient(135deg, #28a745 0%, #218838 100%)",
                    padding: "20px",
                    borderRadius: "10px",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => filterByStatus("2")}
                >
                  <div style={{ fontSize: "14px", opacity: 0.9 }}>
                    Completed
                  </div>
                  <div style={{ fontSize: "32px", fontWeight: "bold" }}>
                    {stats.completed}
                  </div>
                </div>

                <div
                  className="stat-card"
                  style={{
                    background:
                      "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                    padding: "20px",
                    borderRadius: "10px",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => filterByStatus("5")}
                >
                  <div style={{ fontSize: "14px", opacity: 0.9 }}>Hot</div>
                  <div style={{ fontSize: "32px", fontWeight: "bold" }}>
                    {stats.hot}
                  </div>
                </div>

                <div
                  className="stat-card"
                  style={{
                    background:
                      "linear-gradient(135deg, #fd7e14 0%, #e96208 100%)",
                    padding: "20px",
                    borderRadius: "10px",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => filterByStatus("3")}
                >
                  <div style={{ fontSize: "14px", opacity: 0.9 }}>Warm</div>
                  <div style={{ fontSize: "32px", fontWeight: "bold" }}>
                    {stats.warm}
                  </div>
                </div>

                <div
                  className="stat-card"
                  style={{
                    background:
                      "linear-gradient(135deg, #6c757d 0%, #545b62 100%)",
                    padding: "20px",
                    borderRadius: "10px",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => filterByStatus("4")}
                >
                  <div style={{ fontSize: "14px", opacity: 0.9 }}>Cold</div>
                  <div style={{ fontSize: "32px", fontWeight: "bold" }}>
                    {stats.cold}
                  </div>
                </div>

                <div
                  className="stat-card"
                  style={{
                    background:
                      "linear-gradient(135deg, #343a40 0%, #23272b 100%)",
                    padding: "20px",
                    borderRadius: "10px",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={() => filterByStatus("10")}
                >
                  <div style={{ fontSize: "14px", opacity: 0.9 }}>Rejected</div>
                  <div style={{ fontSize: "32px", fontWeight: "bold" }}>
                    {stats.rejected}
                  </div>
                </div>
              </div>

              {/* Filters and Actions */}
              <div className="page_body">
                <div
                  className="create_new_campaign"
                  style={{ marginBottom: "20px" }}
                >
                  <div className="dateRange">
                    <div className="d-flex gap-3 align-items-center flex-wrap">
                      <div className="inputDiv">
                        <label className="label">
                          <div className="label_content">From</div>
                        </label>
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormat="dd-MM-yyyy"
                          className="inputField"
                          placeholderText="From Date"
                        />
                      </div>
                      <div className="inputDiv">
                        <label className="label">
                          <div className="label_content">To</div>
                        </label>
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          dateFormat="dd-MM-yyyy"
                          className="inputField"
                          placeholderText="To Date"
                        />
                      </div>
                      <button
                        type="button"
                        className="submitBtn"
                        onClick={search_data}
                      >
                        <Search size={16} style={{ marginRight: "5px" }} />
                        Search
                      </button>
                      <button
                        type="button"
                        className="submitBtn"
                        onClick={exportToCSV}
                        style={{ backgroundColor: "#28a745" }}
                      >
                        <Download size={16} style={{ marginRight: "5px" }} />
                        Export CSV
                      </button>
                      <button
                        type="button"
                        className="submitBtn"
                        onClick={openShowModal}
                        style={{ backgroundColor: "#007bff" }}
                      >
                        <UserPlus size={16} style={{ marginRight: "5px" }} />
                        Add Lead
                      </button>
                    </div>
                  </div>
                </div>

                <div className="page_body_container">
                  {/* Search Bar */}
                  <div className="searchInput" style={{ marginBottom: "20px" }}>
                    <div className="searchInputDiv">
                      <Search className="searchInputImg" size={20} />
                      <input
                        type="text"
                        value={searchfilter}
                        onChange={handleSearch}
                        placeholder="Search by name, email, phone, city, restaurant..."
                      />
                    </div>
                  </div>

                  {/* Table */}
                  <div className="table_container">
                    <table
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: "#f8f9fa" }}>
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              width: "40px",
                            }}
                          >
                            #
                          </th>
                          <th style={{ padding: "12px", textAlign: "left" }}>
                            Entry Date
                          </th>
                          <th style={{ padding: "12px", textAlign: "left" }}>
                            Contact Info
                          </th>
                          <th style={{ padding: "12px", textAlign: "left" }}>
                            Restaurant Details
                          </th>
                          <th style={{ padding: "12px", textAlign: "left" }}>
                            Status
                          </th>
                          <th style={{ padding: "12px", textAlign: "left" }}>
                            Assigned To
                          </th>
                          <th style={{ padding: "12px", textAlign: "center" }}>
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((item, index) => (
                          <React.Fragment key={item.primary_id}>
                            <tr
                              style={{
                                borderBottom: "1px solid #e9ecef",
                                backgroundColor: expandedRows.includes(
                                  item.primary_id,
                                )
                                  ? "#f8f9fa"
                                  : "white",
                              }}
                            >
                              <td style={{ padding: "12px" }}>
                                <button
                                  onClick={() =>
                                    toggleRowExpansion(item.primary_id)
                                  }
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "#007bff",
                                  }}
                                >
                                  {expandedRows.includes(item.primary_id) ? (
                                    <FaChevronUp />
                                  ) : (
                                    <FaChevronDown />
                                  )}
                                </button>
                              </td>
                              <td style={{ padding: "12px" }}>
                                <div
                                  style={{ fontSize: "13px", color: "#666" }}
                                >
                                  {item.entry_date
                                    ? new Date(
                                        item.entry_date,
                                      ).toLocaleDateString()
                                    : "N/A"}
                                </div>
                              </td>
                              <td style={{ padding: "12px" }}>
                                <div style={{ marginBottom: "5px" }}>
                                  <FaUser
                                    style={{
                                      marginRight: "5px",
                                      color: "#6c757d",
                                    }}
                                  />
                                  <strong>{item.full_name || "N/A"}</strong>
                                </div>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    color: "#666",
                                    marginBottom: "3px",
                                  }}
                                >
                                  <FaEnvelope style={{ marginRight: "5px" }} />
                                  {item.email_address || "N/A"}
                                </div>
                                <div
                                  style={{ fontSize: "13px", color: "#666" }}
                                >
                                  <FaPhone style={{ marginRight: "5px" }} />
                                  {item.phone_number || "N/A"}
                                </div>

                                <div
                                  style={{ fontSize: "13px", color: "#666" }}
                                >
                                  {item.current_url || "N/A"}
                                </div>
                              </td>
                              <td style={{ padding: "12px" }}>
                                <div style={{ marginBottom: "5px" }}>
                                  <FaUtensils
                                    style={{
                                      marginRight: "5px",
                                      color: "#6c757d",
                                    }}
                                  />
                                  <strong>
                                    {item.restaurant_name || "N/A"}
                                  </strong>
                                </div>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    color: "#666",
                                    marginBottom: "3px",
                                  }}
                                >
                                  Type: {item.restaurant_type || "N/A"}
                                </div>
                                <div
                                  style={{
                                    fontSize: "13px",
                                    color: "#666",
                                    marginBottom: "3px",
                                  }}
                                >
                                  <FaMapMarkerAlt
                                    style={{ marginRight: "5px" }}
                                  />
                                  {item.city || "N/A"}
                                </div>
                                <div
                                  style={{ fontSize: "13px", color: "#666" }}
                                >
                                  <FaStore style={{ marginRight: "5px" }} />
                                  {item.no_outlets || "0"} outlets
                                </div>
                              </td>
                              <td style={{ padding: "12px" }}>
                                {getStatusBadge(item.active_status)}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {item.assign_to ? (
                                  <span
                                    style={{
                                      padding: "5px 10px",
                                      backgroundColor: "#e7f3ff",
                                      borderRadius: "5px",
                                      fontSize: "12px",
                                    }}
                                  >
                                    ID: {item.assign_to}
                                  </span>
                                ) : (
                                  <span
                                    style={{ color: "#999", fontSize: "12px" }}
                                  >
                                    Unassigned
                                  </span>
                                )}
                              </td>
                              <td
                                style={{ padding: "12px", textAlign: "center" }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "5px",
                                    justifyContent: "center",
                                  }}
                                >
                                  <button
                                    onClick={() => openDetailModal(item)}
                                    style={{
                                      padding: "6px 12px",
                                      backgroundColor: "#17a2b8",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                    title="View Details"
                                  >
                                    <FaEye />
                                  </button>
                                  <button
                                    onClick={() =>
                                      openModal1(
                                        item.primary_id,
                                        item.active_status,
                                      )
                                    }
                                    style={{
                                      padding: "6px 12px",
                                      backgroundColor: "#ffc107",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                    title="Update Status"
                                  >
                                    <FaPen />
                                  </button>
                                  <button
                                    onClick={() => openAssignModal(item)}
                                    style={{
                                      padding: "6px 12px",
                                      backgroundColor: "#28a745",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                    title="Assign Lead"
                                  >
                                    <UserPlus size={14} />
                                  </button>
                                </div>
                              </td>
                            </tr>

                            {/* Expanded Row */}
                            {expandedRows.includes(item.primary_id) && (
                              <tr style={{ backgroundColor: "#f8f9fa" }}>
                                <td colSpan="7" style={{ padding: "15px" }}>
                                  <div
                                    style={{
                                      backgroundColor: "white",
                                      padding: "15px",
                                      borderRadius: "8px",
                                      border: "1px solid #dee2e6",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns:
                                          "repeat(auto-fit, minmax(250px, 1fr))",
                                        gap: "15px",
                                      }}
                                    >
                                      <div>
                                        <strong style={{ color: "#495057" }}>
                                          Message:
                                        </strong>
                                        <p
                                          style={{
                                            margin: "5px 0",
                                            fontSize: "14px",
                                            color: "#666",
                                          }}
                                        >
                                          {item.message || "No message"}
                                        </p>
                                      </div>
                                      <div>
                                        <strong style={{ color: "#495057" }}>
                                          Remark:
                                        </strong>
                                        <p
                                          style={{
                                            margin: "5px 0",
                                            fontSize: "14px",
                                            color: "#666",
                                          }}
                                        >
                                          {item.remark || "No remark"}
                                        </p>
                                      </div>
                                      <div>
                                        <strong style={{ color: "#495057" }}>
                                          Current URL:
                                        </strong>
                                        <p
                                          style={{
                                            margin: "5px 0",
                                            fontSize: "14px",
                                            color: "#666",
                                            wordBreak: "break-all",
                                          }}
                                        >
                                          {item.current_url || "N/A"}
                                        </p>
                                      </div>
                                      <div>
                                        <strong style={{ color: "#495057" }}>
                                          Remark Status:
                                        </strong>
                                        <p
                                          style={{
                                            margin: "5px 0",
                                            fontSize: "14px",
                                            color: "#666",
                                          }}
                                        >
                                          {item.remark_status || "0"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>

                    {filteredData.length === 0 && (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "40px",
                          color: "#999",
                        }}
                      >
                        No leads found
                      </div>
                    )}
                  </div>

                  {/* Pagination */}
                  <div
                    className="pagination-container"
                    style={{ marginTop: "20px" }}
                  >
                    <Pagination>
                      <Pagination.First
                        onClick={() => handlePageChange(1)}
                        disabled={currentPage === 1}
                      />
                      <Pagination.Prev
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      />
                      {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item
                          key={index + 1}
                          active={index + 1 === currentPage}
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      />
                      <Pagination.Last
                        onClick={() => handlePageChange(totalPages)}
                        disabled={currentPage === totalPages}
                      />
                    </Pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Update Status Modal */}
        <Modal
          show={showModal1}
          onHide={closeModal1}
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Lead Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <label
                style={{
                  fontWeight: "500",
                  marginBottom: "10px",
                  display: "block",
                }}
              >
                Select Status
              </label>
              <select
                className="form-select"
                value={dropdownoptions}
                onChange={(e) => setdropdownoption(e.target.value)}
                style={{ marginBottom: "15px" }}
              >
                <option value="0">Pending</option>
                <option value="1">In Progress</option>
                <option value="2">Completed</option>
                <option value="5">Hot</option>
                <option value="3">Warm</option>
                <option value="4">Cold</option>
                <option value="10">Rejected</option>
              </select>

              {dropdownoptions === "10" && (
                <div>
                  <label
                    style={{
                      fontWeight: "500",
                      marginBottom: "10px",
                      display: "block",
                    }}
                  >
                    Rejection Reason
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Enter reason for rejection..."
                    value={rejectresion}
                    onChange={(e) =>
                      setrejectresion(sanitizeText(e.target.value))
                    }
                  />
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="logoutYesBtn"
              onClick={master_data_action_update}
            >
              Update
            </Button>
            <Button className="logoutNoBtn" onClick={closeModal1}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add Lead Modal */}
        <Modal
          show={showAddModal}
          onHide={closeEditModal}
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add New Lead</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form id="AddSubsData">
              <div className="form-group" style={{ marginBottom: "15px" }}>
                <label style={{ fontWeight: "500" }}>Full Name *</label>
                <input
                  type="text"
                  className="form-control trio_mandatory"
                  id="full_name"
                  name="full_name"
                  maxLength={100}
                  placeholder="Enter full name"
                />
                <span className="condition_error"></span>
              </div>

              <div className="form-group" style={{ marginBottom: "15px" }}>
                <label style={{ fontWeight: "500" }}>Email Address *</label>
                <input
                  type="email"
                  className="form-control trio_mandatory"
                  id="email_address"
                  name="email_address"
                  maxLength={150}
                  placeholder="Enter email"
                />
                <span className="condition_error"></span>
              </div>

              <div className="form-group" style={{ marginBottom: "15px" }}>
                <label style={{ fontWeight: "500" }}>Phone Number *</label>
                <input
                  type="text"
                  className="form-control trio_mandatory"
                  id="phone_number"
                  name="phone_number"
                  maxLength={15}
                  placeholder="Enter phone number"
                />
                <span className="condition_error"></span>
              </div>

              <div className="form-group" style={{ marginBottom: "15px" }}>
                <label style={{ fontWeight: "500" }}>City</label>
                <input
                  type="text"
                  className="form-control"
                  id="city"
                  name="city"
                  maxLength={100}
                  placeholder="Enter city"
                />
              </div>

              <div className="form-group" style={{ marginBottom: "15px" }}>
                <label style={{ fontWeight: "500" }}>Restaurant Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="restaurant_name"
                  name="restaurant_name"
                  maxLength={150}
                  placeholder="Enter restaurant name"
                />
              </div>

              <div className="form-group" style={{ marginBottom: "15px" }}>
                <label style={{ fontWeight: "500" }}>Restaurant Type</label>
                <input
                  type="text"
                  className="form-control"
                  id="restaurant_type"
                  name="restaurant_type"
                  maxLength={100}
                  placeholder="E.g., Fine Dining, QSR, Cafe"
                />
              </div>

              <div className="form-group" style={{ marginBottom: "15px" }}>
                <label style={{ fontWeight: "500" }}>Number of Outlets</label>
                <input
                  type="text"
                  inputMode="numeric"
                  className="form-control"
                  id="no_outlets"
                  name="no_outlets"
                  maxLength={6}
                  placeholder="Enter number of outlets"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                />
              </div>

              <div className="form-group" style={{ marginBottom: "15px" }}>
                <label style={{ fontWeight: "500" }}>Message</label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows="3"
                  maxLength={1000}
                  placeholder="Enter message or notes"
                />
              </div>

              <div className="form-group" style={{ marginBottom: "15px" }}>
                <label style={{ fontWeight: "500" }}>Status</label>
                <select
                  className="form-select"
                  value={dropdownoptions}
                  onChange={(e) => setdropdownoption(e.target.value)}
                >
                  <option value="0">Pending</option>
                  <option value="1">In Progress</option>
                  <option value="2">Completed</option>
                  <option value="5">Hot</option>
                  <option value="3">Warm</option>
                  <option value="4">Cold</option>
                  <option value="10">Rejected</option>
                </select>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeEditModal}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => handleSaveChanges_add("AddSubsData", contact_save)}
            >
              Save Lead
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Details Modal */}
        <Modal
          show={showDetailModal}
          onHide={closeDetailtModal}
          centered
          backdrop="static"
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Lead Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
              }}
            >
              <div>
                <strong>Full Name:</strong>
                <p>{selectedRestaurant?.full_name || "N/A"}</p>
              </div>
              <div>
                <strong>Email:</strong>
                <p>{selectedRestaurant?.email_address || "N/A"}</p>
              </div>
              <div>
                <strong>Phone:</strong>
                <p>{selectedRestaurant?.phone_number || "N/A"}</p>
              </div>
              <div>
                <strong>City:</strong>
                <p>{selectedRestaurant?.city || "N/A"}</p>
              </div>
              <div>
                <strong>Restaurant Name:</strong>
                <p>{selectedRestaurant?.restaurant_name || "N/A"}</p>
              </div>
              <div>
                <strong>Restaurant Type:</strong>
                <p>{selectedRestaurant?.restaurant_type || "N/A"}</p>
              </div>
              <div>
                <strong>Number of Outlets:</strong>
                <p>{selectedRestaurant?.no_outlets || "N/A"}</p>
              </div>
              <div>
                <strong>Status:</strong>
                <p>{getStatusBadge(selectedRestaurant?.active_status)}</p>
              </div>
              <div style={{ gridColumn: "1 / -1" }}>
                <strong>Message:</strong>
                <p>{selectedRestaurant?.message || "No message"}</p>
              </div>
              <div style={{ gridColumn: "1 / -1" }}>
                <strong>Remark:</strong>
                <p>{selectedRestaurant?.remark || "No remark"}</p>
              </div>
              <div style={{ gridColumn: "1 / -1" }}>
                <strong>Current URL:</strong>
                <p style={{ wordBreak: "break-all" }}>
                  {selectedRestaurant?.current_url || "N/A"}
                </p>
              </div>
              <div>
                <strong>Assigned To:</strong>
                <p>{selectedRestaurant?.assign_to || "Unassigned"}</p>
              </div>
              <div>
                <strong>Entry Date:</strong>
                <p>
                  {selectedRestaurant?.entry_date
                    ? new Date(selectedRestaurant.entry_date).toLocaleString()
                    : "N/A"}
                </p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeDetailtModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Assign Modal */}
        <Modal
          show={showAssignModal}
          onHide={closeEditModal}
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Assign Lead</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <label
                style={{
                  fontWeight: "500",
                  marginBottom: "10px",
                  display: "block",
                }}
              >
                Assign To (User ID)
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter user ID to assign"
                value={assignToValue}
                maxLength={20}
                onChange={(e) => {
                  // User ID field — allow alphanumerics/underscore/hyphen only
                  const clean = e.target.value.replace(/[^a-zA-Z0-9_-]/g, "");
                  setAssignToValue(clean);
                }}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeEditModal}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                if (!assignToValue.trim()) {
                  handleError("Please enter a user ID to assign");
                  return;
                }
                // TODO: wire this to an actual assign-lead API call using
                // selectedRestaurant.primary_id + assignToValue (sanitized above)
                handleSuccess("Lead assigned successfully!");
                closeEditModal();
              }}
            >
              Assign
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default LeadManagement;
